<template>
    <common-button
        :label="$t('pages.practice.create.create_company.create')"
        type="add-referral"
        size="medium"
        :icon="'referral-add'"
        @click="createCompany()"
    ></common-button>
</template>

<script>
    export default {
        methods: {
            createCompany() {
                this.$router.push({
                    name: 'company.create',
                })
            },
        },
    }
</script>
